import React from 'react';
import NotesPanel from './NotesPanel';

/**
 * Thin wrapper so the dialog imports something semantically named
 * "NotesTab" - all real logic lives in NotesPanel, shared with
 * ContactNotesDrawer.
 */
export default function NotesTab(props) {
  return <NotesPanel {...props} variant="tab" />;
}